// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__k3iLY","alert":"SettungsInbox_alert__3BpZf"};